import { render, staticRenderFns } from "./BoardFilterDefaultLayout.vue?vue&type=template&id=76da7958&scoped=true&"
import script from "./BoardFilterDefaultLayout.vue?vue&type=script&lang=js&"
export * from "./BoardFilterDefaultLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76da7958",
  null
  
)

export default component.exports